import { Component, EventEmitter, Input, Output } from '@angular/core';

import type { Observable, Subscription } from 'rxjs';

/**
 * Component to display a loading dialog when an observable/promise/sub is running
 */
@Component({
  selector: 'mtx-loading-dialog',
  standalone: false,
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
})
export class LoadingDialogComponent {

  /** Promise/observable/sub passed from element to watch */
  @Input() public watch?: Observable<any> | Promise<any> | Subscription | boolean;

  @Input() public displayText = 'Loading...';

  @Input() public cancel = false;

  @Output() public loadCancelled = new EventEmitter<void>();

  public cancelLoad(): void {
    this.loadCancelled.emit();
  }

}
